(function () {

  let _chairHandlesCache = null;

  async function getChairHandles() {
    if (_chairHandlesCache) return _chairHandlesCache;
    try {
      const el = document.getElementById('pillow-chair-handles');
      return el ? JSON.parse(el.textContent) : [];
    } catch (e) { return []; }
  }

  function getActiveAddons() {
    try {
      const el = document.getElementById('pillow-active-addons');
      return el ? JSON.parse(el.textContent) : [];
    } catch (e) { return []; }
  }

  const NECK = {
    handle: "ttracing-threadmark-pillow",
    zakekeUrl: "apps/zakeke?pid=7967964823614&handle=ttracing-threadmark-pillow&locale=en",
    image: "//ttracing.my/cdn/shop/files/1-threadmark-pillow-black_400x.png?v=1770361711",
    label: "Personalize neck pillow",
    price: "+RM79",
    cls: "addon-line-neck"
  };

  const LUMBAR = {
    handle: "ttracing-threadmark-lumbar-pillow",
    zakekeUrl:
      "apps/zakeke?pid=8079445131326&handle=ttracing-threadmark-lumbar-pillow&locale=en",
    image:
      "//ttracing.my/cdn/shop/files/1new-threadmark-lumbar-pillow-black_400x.png?v=1778485776",
    label: "Personalize lumbar pillow",
    price: "+RM99",
    cls: "addon-line-lumbar",
  };

  const FOOTBALL = {
    handle: "ttracing-threadmark-neck-pillow-football-edition",
    zakekeUrl: "apps/zakeke?pid=8124662022206&handle=ttracing-threadmark-neck-pillow-football-edition&locale=en",
    image: "https://cdn.shopify.com/s/files/1/2021/9723/files/fifa1-threadmark-pillow-black2.png?v=1781413864",
    label: "Personalize football neck pillow",
    price: "+RM89",
    cls: "addon-line-football",
  };

  let isProcessing = false;

  async function updateAddonLine() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const chairHandles = getChairHandles();
      const chairItems = cart.items.filter(item => chairHandles.includes(item.handle));

      // Stamp data-is-pillow-chair for qty listener
      cart.items.forEach(item => {
        const el = document.querySelector(`.cart__item[data-key="${item.key}"]`);
        if (el) el.dataset.isPillowChair = chairHandles.includes(item.handle) ? 'true' : 'false';
      });
      const neckItems = cart.items.filter(item => item.handle === NECK.handle);
      const lumbarItems = cart.items.filter(item => item.handle === LUMBAR.handle);
      const footballItems = cart.items.filter(item => item.handle === FOOTBALL.handle);

      renderAddonUI(chairItems, neckItems, lumbarItems, footballItems);
    } catch (err) {
      console.error("Cart page addon check failed", err);
    } finally {
      isProcessing = false;
    }
  }

  function renderAddonUI(chairItems, neckItems, lumbarItems, footballItems) {
    chairItems.forEach(chair => {
      const matchingRow = document.querySelector(`.cart__item[data-key="${chair.key}"]`);
      if (!matchingRow) return;

      const activeAddons = getActiveAddons();
      const neckLinked = !activeAddons.includes(NECK.handle) || neckItems.filter(p => Number(p.properties?._linked_chair_variant_id) === chair.variant_id).length >= chair.quantity;
      const lumbarLinked = !activeAddons.includes(LUMBAR.handle) || lumbarItems.filter(p => Number(p.properties?._linked_chair_variant_id) === chair.variant_id).length >= chair.quantity;
      const footballLinked = !activeAddons.includes(FOOTBALL.handle) || footballItems.filter(p => Number(p.properties?._linked_chair_variant_id) === chair.variant_id).length >= chair.quantity;

      const existingWrapper = matchingRow.querySelector('.addon-lines-wrapper');

      // Skip re-render if linked state hasn't changed
      if (existingWrapper) {
        const sameNeck = existingWrapper.dataset.neckLinked === String(neckLinked);
        const sameLumbar = existingWrapper.dataset.lumbarLinked === String(lumbarLinked);
        const sameFootball = existingWrapper.dataset.footballLinked === String(footballLinked);
        if (sameNeck && sameLumbar && sameFootball) return;
        existingWrapper.remove();
      }

      if (neckLinked && lumbarLinked && footballLinked) return;

      const warrantyCard = matchingRow.querySelector('.cart-addon-card');
      const pillowCustom = matchingRow.querySelector('.cart-pillow-custom');
      const priceCol = matchingRow.querySelector('.cart__item-price-col');
      if (!warrantyCard && !pillowCustom && !priceCol) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'addon-lines-wrapper';
      wrapper.dataset.neckLinked = String(neckLinked);
      wrapper.dataset.lumbarLinked = String(lumbarLinked);
      wrapper.dataset.footballLinked = String(footballLinked);

      if (!neckLinked) wrapper.appendChild(buildAddonDiv(NECK, chair.variant_id));
      if (!lumbarLinked) wrapper.appendChild(buildAddonDiv(LUMBAR, chair.variant_id));
      if (!footballLinked) wrapper.appendChild(buildAddonDiv(FOOTBALL, chair.variant_id));

      if (warrantyCard) {
        warrantyCard.insertAdjacentElement('afterend', wrapper);
      } else if (pillowCustom) {
        pillowCustom.insertAdjacentElement('beforebegin', wrapper);
      } else {
        priceCol.insertAdjacentElement('afterend', wrapper);
      }
    });

  }

  function buildAddonDiv(addon, chairVariantId) {
    const a = document.createElement('a');
    a.className = 'addon-line-custom ' + addon.cls;
    a.href = `/${addon.zakekeUrl}&linked_chair=${chairVariantId}`;
    a.innerHTML = `
      <span class="addon-line-badge">Add on ${addon.price}</span>
      <div class="pillow-img" style="display: flex; align-items: center; min-height: 45px;"><img src="${addon.image}"></div>
      <div class="addon-line-inner" style="display:flex; gap: 10px; justify-content:space-between; font-size:14px; align-items:center; flex:1;">
        <span>${addon.label}</span>
      </div>
    `;
    return a;
  }


  function bindCartPageChairListeners() {
    function isTargetChairItem(el) {
      const itemEl = el.closest('.cart__item');
      return itemEl && itemEl.dataset.isPillowChair === 'true';
    }

    function disableAddonLinks() {
      document.querySelectorAll('.addon-line-custom, .cart-pillow-custom a').forEach(el => {
        el.style.pointerEvents = 'none';
        el.style.cursor = 'default';
      });
    }

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.js-qty__adjust');
      if (btn && isTargetChairItem(btn)) disableAddonLinks();
    }, true);

    document.addEventListener('change', (e) => {
      const input = e.target.closest('.js-qty__num');
      if (input && isTargetChairItem(input)) disableAddonLinks();
    }, true);
  }

  document.addEventListener('cart:updated', updateAddonLine);
  document.addEventListener('DOMContentLoaded', () => {
    updateAddonLine();
    bindCartPageChairListeners();
  });

})();
